import { cn } from '~/shadcn/lib/utils'

type Props = React.HTMLAttributes<HTMLHeadingElement>

function HeadingOne({ className, ...props }: Props) {
  return (
    <h1
      className={cn(
        'text-[2.5rem]/[1.2] leading font-semibold tracking-[0.1rem]',
        'md:text-[3.5rem]',
        className
      )}
      {...props}
    />
  )
}

export { HeadingOne }
